import React ,{useState} from 'react';
import { Link } from 'react-router-dom'
import Marquee from "react-fast-marquee";
import Bg from '../../../images/bg/da-footer.jpg'
import logo from '../../../images/logo/techstrv1.png'
import icon1 from '../../../images/icon/email.png'
import icon2 from '../../../images/icon/sms.svg'
import { ToastContainer, toast } from 'react-toastify';
 const apiData = "https://ajun.app.n8n.cloud/webhook/22a241de-7871-4011-849b-080fd75dacc8" 
const ClickHandler = () => {
  window.scrollTo(10, 0);
}

const Footer = (props) => {
  var currentYear = new Date().getFullYear();
   const [successm, setSuccessm] = useState(false);
      const [message, setMessage] = useState({
        type: "success",
        info: "Form submission failed. Please try again."
      });
      const [btnDisabled , setBtnDisabled] = useState(false);
       const formHandlerSubmit = async (e) => {
      e.preventDefault();
      setBtnDisabled(true);
  
        const f = e.target;
        const data = new FormData(f);
        const formData = Object.fromEntries(data);
        const createdby = new Date();
        const options = {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        };
        const formattedDate = createdby.toLocaleString("en-US", options);
        formData.Date = formattedDate;
  
  
    try {
      const response = await fetch(apiData, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData),
      });
  
      f.reset();
      if (response.ok) {
          console.log(response)
      toast.success("Thank You for Subscribing");
      } else {
        toast.error("Submission failed. Try again.");
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    }
  
    setSuccessm(true);
  
    setTimeout(() => {
      setSuccessm(false);
      setBtnDisabled(false);
      setMessage("");
    }, 3000);
      }
  return (
    <footer className="footer footer-style-six pb-80 bg_img pos-rel bg_img" style={{ backgroundImage: `url(${Bg})` }}>
       
    
      <div className="da-footer-title">
        <h2 className="title marquee-left">
          <Link onClick={ClickHandler} to="/">
            <div className="marquee">
              <div className="marquee-content">
                <Marquee speed={50} gradient={false}>
                  Book a Discover Call Now <span>Take advantage of our expert knowledge.</span>
                  Book a Discover Call Now <span>Take advantage of our expert knowledge.</span>
                </Marquee>
              </div>
            </div>
          </Link>
        </h2>
      </div>
      <div className="container">
        
        <div className="xb-footer">
          <div className="row pb-95">
          <div className="">
            <div className="xb-newslatter">
              <div className="xb-item--icon">
                <img src={icon1} alt="" />
              </div>
              <h2 className="xb-item--title">Subscribe us</h2>
              <span className="xb-item--content">Want to stay up to date? Sign up for innomax it services update.</span>
              <form className="xb-item--contact mt-35" onSubmit={formHandlerSubmit}>
                <div className="xb-item--input_field pos-rel">
                  <input type="email" name="Email" id="Email" placeholder="enter your email" required/>
                  <div className="img"><img src={icon2} alt="" /></div>
                </div>
                <button className="xb-item--button btn-effect_2" disabled={btnDisabled}>{btnDisabled ? "Processing..." : "Subscribe Us"}</button>
                <span className="xb-item--text">Don't worry about spam. We hate it too!</span>
              </form>
            </div>
          </div>
          </div>
          <div className="da-footer-inner ul_li_between mt-none-30">
            <div className="xb-item--left mt-10">
              <div className="xb-item--logo mt-20">
                <Link onClick={ClickHandler} to="/home-3"><img src={logo} alt="" /></Link>
              </div>
              <span className="xb-item--content mt-20">ServcieNow Solution</span>
            </div>
            <ul className="xb-item--nav_item mt-30 list-unstyled ul_li">
              <li><Link onClick={ClickHandler} to="/company">Company</Link></li>
              <li><Link onClick={ClickHandler} to="/service">Services</Link></li>
              <li><Link onClick={ClickHandler} to="/blog">Blog</Link></li>
              <li><Link onClick={ClickHandler} to="/career">Career</Link></li>
              <li><Link onClick={ClickHandler} to="/contact">Contact</Link></li>
            </ul>
          </div>
          
          <div className="footer-copyright mt-40 ul_li_between">
            <p className="copyright">©Copyright {currentYear} <Link onClick={ClickHandler} to="/home-3">TechStr</Link>. All rights reserved.</p>
            <ul className="footer-links ul_li">
              <li><Link onClick={ClickHandler} to="/terms-conditions">Terms & Conditions </Link></li>
              <li><Link onClick={ClickHandler} to="/privacy-policy">Privacy Policy</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer;